<template>
    <u-textarea-filled-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-filled-rounded>
</template>

<script>
import UTextareaFilledRounded from "@/components/publish/styles/forms/u-textarea-filled-rounded.vue";

export default {
    props: {},
    components: {
        UTextareaFilledRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
